import React from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import moment from "moment";
import { monthNames } from "../../lib/data";

const TOTAL_MONTHS = 13;

const MonthPicker = (props) => {
    const { onClose, selectedValue, open, thirteenMonthNotVisible } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    const [firstColumn, secondColumn] = createMonthColumns(
        thirteenMonthNotVisible,
    );

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            <DialogTitle
                id="simple-dialog-title"
                style={{ textAlign: "center" }}
            >
                Выберите месяц
            </DialogTitle>
            <div
                style={{
                    display: "flex",
                    padding: "1rem",
                    textTransform: "capitalize",
                }}
            >
                <div>
                    {firstColumn.map((monthName) => (
                        <ListItem
                            button
                            onClick={() => handleListItemClick(monthName)}
                            key={monthName}
                            style={{ textAlign: "center" }}
                        >
                            <ListItemText primary={monthName} />
                        </ListItem>
                    ))}
                </div>
                <div>
                    {secondColumn.map((monthName) => (
                        <ListItem
                            button
                            onClick={() => handleListItemClick(monthName)}
                            key={monthName}
                            style={{ textAlign: "center" }}
                        >
                            <ListItemText primary={monthName} />
                        </ListItem>
                    ))}
                </div>
            </div>
        </Dialog>
    );
};

// Helper functions
// Creates 2 columns of available month six each
const createMonthColumns = (thirteenthVisible) => {
    const curMonth = moment();

    const firstCol = [];
    const secondCol = [];

    firstCol.push(
        `${monthNames[parseInt(curMonth.format("M")) - 1]} ${curMonth.format(
            "YYYY",
        )}`,
    );
    for (let i = 1; i < TOTAL_MONTHS; i++) {
        const newCurMonth = moment();
        const nextMonth = newCurMonth.add(i, "M");
        if (firstCol?.length < TOTAL_MONTHS / 2) {
            firstCol.push(
                `${
                    monthNames[parseInt(nextMonth.format("M")) - 1]
                } ${nextMonth.format("YYYY")}`,
            );
        } else {
            if (thirteenthVisible && i === TOTAL_MONTHS - 1) break;
            secondCol.push(
                `${
                    monthNames[parseInt(nextMonth.format("M")) - 1]
                } ${nextMonth.format("YYYY")}`,
            );
        }
    }

    return [firstCol, secondCol];
};

MonthPicker.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.object,
    thirteenMonthNotVisible: PropTypes.bool,
};

export default MonthPicker;
